import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Calculator = createReactComponent("Calculator", ["svg", defaultAttributes, [["rect", {
  x: "4",
  y: "2",
  width: "16",
  height: "20",
  rx: "2",
  key: "1ft04i"
}], ["line", {
  x1: "8",
  x2: "16",
  y1: "6",
  y2: "6",
  key: "19xyj3"
}], ["line", {
  x1: "16",
  x2: "16",
  y1: "14",
  y2: "18",
  key: "1hm6pj"
}], ["path", {
  d: "M16 10h.01",
  key: "1yhyjk"
}], ["path", {
  d: "M12 10h.01",
  key: "11wgo0"
}], ["path", {
  d: "M8 10h.01",
  key: "9s5hzm"
}], ["path", {
  d: "M12 14h.01",
  key: "rao6x9"
}], ["path", {
  d: "M8 14h.01",
  key: "2jug5y"
}], ["path", {
  d: "M12 18h.01",
  key: "5lmu0x"
}], ["path", {
  d: "M8 18h.01",
  key: "1sjb0i"
}]]]);
export default Calculator;